import DonutChartWithYear from './charts/donut-chart-with-year/DonutChartWithYear'

export function baseDonutCmp(apiFn) {
  return {
    props: {
      title: String
    },

    render(h) {
      return h(DonutChartWithYear, {
        props: {
          apiFn,
          title: this.title
        },
        scopedSlots: this.$scopedSlots
      })
    }
  }
}
